export const createOneToOneOptions = (arr: string[]) => {
	return arr.map((item) => ({
		label: item,
		value: item,
	}));
};
